import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ug-bachelor-of-science-hospitality-studies',
  templateUrl: './ug-bachelor-of-science-hospitality-studies.component.html',
  styleUrls: ['./ug-bachelor-of-science-hospitality-studies.component.scss']
})
export class UgBachelorOfScienceHospitalityStudiesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
